export const Z_INDEX = {
    FLYOUT_HIGH: 2,
    FLYOUT_LOW: 0,
    FLYOUT_MEDIUM: 1
};
